"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyCommentsContainer = exports.SurveyCommentsCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const UserDiscourseItem_1 = require("../../_shared/components/UserDiscourseItem");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const DoneAction_1 = require("../actions/DoneAction");
const PreviousQuestionAction_1 = require("../actions/PreviousQuestionAction");
const surveyHelpers_1 = require("../utils/surveyHelpers");
function SurveyCommentsCard(responses, prevQuestionAction) {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem(SurveyCommentsContainer(responses));
    if (prevQuestionAction) {
        card.addAction((0, PreviousQuestionAction_1.PreviousQuestionAction)(prevQuestionAction.surveyId, prevQuestionAction.ordinal));
        card.addAction((0, DoneAction_1.DoneAction)());
    }
    return card;
}
exports.SurveyCommentsCard = SurveyCommentsCard;
function SurveyCommentsContainer(responses) {
    const container = new adaptivecards_1.Container();
    const comments = (0, surveyHelpers_1.getAllResponseComments)(responses);
    container.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: `💬 Comments (${comments.length})`,
        size: adaptivecards_1.TextSize.Medium,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    comments
        .sort((a, b) => b.createdAt.getTime() - a.createdAt.getTime())
        .forEach(comment => {
        const discourse = (0, UserDiscourseItem_1.UserDiscourseItem)({
            name: comment.user.name,
            comment: comment.value,
            timestamp: comment.createdAt,
        });
        discourse.spacing = adaptivecards_1.Spacing.Large;
        discourse.separator = true;
        container.addItem(discourse);
    });
    if (comments.length === 0) {
        const noContainer = CardHelper_1.CardHelper.create(adaptivecards_1.Container, { style: adaptivecards_1.ContainerStyle.Emphasis });
        noContainer.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            text: "No Comments",
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
            size: adaptivecards_1.TextSize.Large,
            color: adaptivecards_1.TextColor.Good,
        }));
        container.addItem(noContainer);
    }
    return container;
}
exports.SurveyCommentsContainer = SurveyCommentsContainer;
//# sourceMappingURL=SurveyCommentsCard.js.map